<template>
  <div class="sel-header sel-header-inner">
    <div class="sel-header-lable">
      <label class="title">业务员:</label>
      <vxe-pulldown ref="xDown">
        <template>
          <a v-if="!isSaleMan"
             class="sel-link"
             @click="focusEvent('xDown')"
             target="_black"
             style="cursor:pointer"
          >{{(saleMan === null || saleMan === '') ? '请选择用户' : saleMan}}</a>
          <span v-if="isSaleMan">{{saleMan}}</span>
        </template>
        <template v-slot:dropdown>
          <div class="people-dropdown">
            <Input
                search
                v-model="filterName"
                placeholder="账户名"
                @on-search="search"
                style="width: 200px"
            />
            <vxe-grid
                highlight-hover-row
                auto-resize
                height="auto"
                class="table-style"
                :pager-config="tablePage"
                :data="tableList"
                :columns="tableColumn"
                @cell-click="cellClickEvent"
                @page-change="pageChange"
            ></vxe-grid>
          </div>
        </template>
      </vxe-pulldown>
    </div>
    <div class="sel-header-lable">
      <label class="title">销售经理:</label>
      <template>
        <span>{{(salesManager === null || salesManager === '') ? '' : salesManager}}</span>
      </template>
    </div>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import getAuthOrization from "@/mixin/getAuthOrization";

  export default {
    mixins: [getAuthOrization],
    data() {
      return {
        isSaleMan: false,
        saleMan: null, // 业务员
        salesManager: null,
        salesManagerId: null,
        tableColumn: [{field: "name", title: "姓名"}], // 表格数据列
        tableList: [], // 业务员列表
        filterName: null,
        loading: false,
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          size: "mini",
        }
      };
    },
    methods: {
      init() {
        this.setData();
      },
      async setData() {
        let userInfo = this.userInfoValue;
        if (userInfo.identityType === 0) {
          this.isSaleMan = true;
          let res = await $api.baseUserSales.request('querySalesDetail', {
            id: userInfo.id
          });
          this.saleMan = userInfo.username;
          if(res.status === 1) {
            this.salesManager = res.data.salesManager;
            this.salesManagerId = res.data.salesManagerId
          }
          
          this.$emit("setSaleMan", {
            salesMan: userInfo.username,
            salesManId: userInfo.id,
            salesManager: this.salesManager,
            salesManagerId: this.salesManagerId,
          }, 1);
        } else {
          this.isSaleMan = false;
          this.saleMan = null;
          this.salesManager = null;
        }
      },
      pageChange(e) {
        this.tablePage.currentPage = e.currentPage;
        this.tablePage.pageSize = e.pageSize;
        this.getUserList();
      },
      setSaleData(saleMan, salesManager) {
        this.saleMan = saleMan;
        this.salesManager = salesManager;
      },
      focusEvent(name) {
        let refs = this.$refs[name];
        this.tablePage.currentPage = 1;
        this.filterName = "";
        this.getUserList();
        refs.showPanel();
      },
      async cellClickEvent({row}) {
        this.saleMan = row.name;
        let res = await $api.baseUserSales.request('querySalesDetail', {
          id: row.id
        });
        if (res.status === 1) {
          this.salesManager = res.data.salesManager;
          this.$emit("setSaleMan", res.data, 1);
          this.$refs.xDown.hidePanel();
        } else if (res.status === 10003) {
          this.salesManager = null;
          this.$emit("setSaleMan", row, 10003);
          this.$refs.xDown.hidePanel();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }

      },
      async getUserList() {
        let res = await $api.user.request('querySaleManagerList', {
          orderBy: 2,
          page: this.tablePage.currentPage,
          rows: this.tablePage.pageSize,
          userName: this.filterName
        });
        if (res.status === 1) {
          this.tablePage.total = res.data.total;
          this.tableList = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      search() {
        this.tablePage.currentPage = 1
        this.getUserList();
      }
    },
  };
</script>

<style>
  .sel-header {
    display: flex;
    width: 834px;
    height: 56px;
   
  }
  .sel-header-inner{
     /* border: 1px solid #E8EAEC; */
  }

  .sel-header-lable {
    background: #fff;
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .sel-header-lable .table-style .vxe-header--column .vxe-cell {
    height: 32px;
    overflow: hidden;
    display: block;
    line-height: 36px;
  }

  .sel-header-lable .ivu-input-wrapper {
    position: absolute;
    right: 10px;
    top: 13px;
    z-index: 999;
  }

  .sel-header-lable .ivu-input {
    border-radius: 0;

  }

  .sel-header-lable + .sel-header-li::before {
    content: "";
    display: block;
    width: 1px;
    height: 56px;
    background-color: #f4f1f4;
    position: absolute;
    left: 0;
    top: 0;
  }

  .sel-header-lable label.title {
    display: block;
    width: 87px;
    float: left;
    text-align: center;
  }

  .sel-header-box .vxe-pulldown--content .vxe-input--inner {
    border: #fff;
    height: 56px;
    line-height: 56px;
    border-radius: 0;
    width: 190px;
    border: 1px solid #f8f8f8;
  }

  .sel-header-box input::-webkit-input-placeholder {
    color: #2d8cf0;
  }

  .sel-header-box input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #2d8cf0;
  }

  .sel-header-box input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #2d8cf0;
  }

  .sel-header-box input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #2d8cf0;
  }

  .people-dropdown {
    width: 400px;
    height: 300px;
    background-color: #fff;
    /* border: 1px solid #dcdfe6; */
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  }

</style>